import {

  ROUTE_DETAILS_REQUEST,
  ROUTE_DETAILS_SUCCESS,
  ROUTE_DETAILS_FAIL,
  ROUTE_DETAILS_RESET,

  STOP_DETAILS_REQUEST,
  STOP_DETAILS_SUCCESS,
  STOP_DETAILS_FAIL,
  STOP_DETAILS_RESET,


  ROUTE_NAMES_REQUEST,
  ROUTE_NAMES_SUCCESS,
  ROUTE_NAMES_FAIL,
  ROUTE_NAMES_RESET,



} from "../constants/gtfsConstants";

export const routeDetailsReducer = (
  state = {
    loading: false,
    data: [],
    status: "",
    error: ""
  },
  action
) => {
  switch (action.type) {
    case ROUTE_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        status: "loading"
      };

    case ROUTE_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        status: "success",
      };

    case ROUTE_DETAILS_FAIL:
      return {
        ...state,
        data: [],
        loading: false,
        error: action.payload,
        status: "error"
      };
    case ROUTE_DETAILS_RESET:
      return {
        ...state,
        loading: false,
        data: [],
        status: "reset",
        error: ""
      };

    default:
      return state;
  }
};


export const stopDetailsReducer = (
  state = {
    loading: false,
    data: [],
    status: "",
    error: ""
  },
  action
) => {
  switch (action.type) {
    case STOP_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        status: "loading"
      };

    case STOP_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        status: "success",
      };

    case STOP_DETAILS_FAIL:
      return {
        ...state,
        data: [],
        loading: false,
        error: action.payload,
        status: "error"
      };
    case STOP_DETAILS_RESET:
      return {
        ...state,
        loading: false,
        data: [],
        status: "reset",
        error: ""
      };

    default:
      return state;
  }
};


export const routeNamesReducer = (
  state = {
    loading: false,
    data: [],
    status: "",
    error: ""
  },
  action
) => {
  switch (action.type) {
    case ROUTE_NAMES_REQUEST:
      return {
        ...state,
        loading: true,
        status: "loading"
      };

    case ROUTE_NAMES_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        status: "success",
      };

    case ROUTE_NAMES_FAIL:
      return {
        ...state,
        data: [],
        loading: false,
        error: action.payload,
        status: "error"
      };
    case ROUTE_NAMES_RESET:
      return {
        ...state,
        loading: false,
        data: [],
        status: "reset",
        error: ""
      };

    default:
      return state;
  }
};

